import { create } from 'zustand';

export interface User {
  id: number;
  username: string;
  created_at?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  isReady: boolean;
  setAuth: (token: string, user: User) => void;
  clearAuth: () => void;
  initAuth: () => void;
}

const TOKEN_KEY = 'wine_token';
const USER_KEY = 'wine_user';

// 启动时只读取一次会话；登录页不等待 effect，也不提前挂载业务页面。
function readSession() {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const user = JSON.parse(localStorage.getItem(USER_KEY) || 'null') as User | null;
    if (token && user?.id) return { token, user };
  } catch { /* 浏览器禁止存储或旧缓存损坏时回到登录页。 */ }
  return { token: null, user: null };
}

export const useAuthStore = create<AuthState>((set) => ({
  ...readSession(),
  isReady: true,
  setAuth: (token, user) => {
    try {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } catch { /* 当前会话仍可使用。 */ }
    set({ token, user, isReady: true });
  },
  clearAuth: () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    } catch { /* 同步内存状态，避免反复跳转。 */ }
    set({ token: null, user: null, isReady: true });
  },
  initAuth: () => set({ ...readSession(), isReady: true })
}));
